import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { LabelS } from '@sorare/core/src/atoms/typography';
import { cardAttributes } from '@sorare/core/src/lib/glossary';
import { lastCellPadding } from '@sorare/marketplace/src/components/searchPlayerTable/SearchTable/ui';
import { SearchTableHeader } from '@sorare/marketplace/src/components/searchPlayerTable/SearchTableHeader';
import { StatsCell } from '@sorare/marketplace/src/components/searchPlayerTable/SearchTableHeader/ui';

import { playerStatTitle } from '#src/components/fixture/FixtureTopPlayersTable/messages.ts';
import type { PlayerScoreView } from '#src/components/fixture/FixtureTopPlayersTable/types.ts';
import {
  BaseballPlayerScoreStats,
  PlayerScoreViewAttributes,
} from '#src/components/fixture/FixtureTopPlayersTable/types.ts';

const LastStatsCell = styled(StatsCell)`
  ${lastCellPadding}
  justify-content: flex-end;
`;

type Props = {
  statsManager: PlayerScoreView;
  displayTotalScore: boolean;
  rightAlignLastCell: boolean;
};

export const FixtureTopPlayersTableHeader = ({
  statsManager,
  displayTotalScore,
  rightAlignLastCell,
}: Props) => {
  return (
    <SearchTableHeader
      firstCell={
        <LabelS>
          <FormattedMessage {...cardAttributes.player} />
        </LabelS>
      }
    >
      {!!displayTotalScore && (
        <StatsCell>
          <LabelS>
            <FormattedMessage
              {...playerStatTitle[BaseballPlayerScoreStats.TOTAL_SCORE]}
            />
          </LabelS>
        </StatsCell>
      )}
      {statsManager[PlayerScoreViewAttributes.PLAYER_SCORE].map((stat, i) => {
        const Cell =
          !rightAlignLastCell ||
          i < statsManager[PlayerScoreViewAttributes.PLAYER_SCORE].length - 1
            ? StatsCell
            : LastStatsCell;

        return (
          <Cell key={stat}>
            <LabelS>
              <FormattedMessage {...playerStatTitle[stat]} />
            </LabelS>
          </Cell>
        );
      })}
    </SearchTableHeader>
  );
};
